import React from "react";
import ConfigSection from "../../ConfigSection";

const BandSection = ({ userDetails, selectedClient }) => {
  return (
    <ConfigSection
      title='Band'
      configType='Band'
      userDetails={userDetails}
      selectedClient={selectedClient}
      configKey='title'
    />
  );
};

export default BandSection;
